import Vue from 'vue'
import App from './App.vue'
import router from './router'
import http from './utils/http'
import utils from './utils/utils'
import Toasted from 'vue-toasted'
import './utils/rem'
import { Button, Rate, Icon, ActionSheet, List, Card, Lazyload, Image, Empty, Tab, Tabs, Toast, Overlay } from 'vant' // 按需导入vant-ui组件

Vue.config.productionTip = false
Vue.config.ignoredElements = ['wx-open-launch-app']
Vue.prototype.$http = http
Vue.use(Toasted)

utils.awaitPostMessage()
// 按需导入vant-ui组件
Vue.use(Button).use(Rate).use(Icon).use(ActionSheet).use(List).use(Card)
    .use(Lazyload).use(Image).use(Empty).use(Tab).use(Tabs).use(Toast).use(Overlay)
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
Vue.directive('title', {
  //单个修改标题
  inserted: function (el) {
    document.title = el.dataset.title
  }
})


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
